const AIRTABLE_API_KEY =
  "patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02";
const BASE_ID = "appD48APNaGA4GN0B";

/**
 * Crée un nouvel enregistrement dans une table Airtable.
 * @param {string} table — Nom de la table (ex : "affaires").
 * @param {object} fields — Objet des champs à créer (ex : { TypeAffaire: "immobilier", … }).
 * @returns {Promise<object>} — Le record complet retourné par Airtable (dont .id).
 */
export async function createAirtableRecord(table, fields) {
  const url = `https://api.airtable.com/v0/${BASE_ID}/${encodeURIComponent(table)}`;
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${AIRTABLE_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fields }),
    });
    if (!response.ok) {
      const errData = await response.json();
      console.error(`Airtable create [${table}] error:`, errData);
      throw new Error(`Airtable création échouée pour "${table}" : ${JSON.stringify(errData)}`);
    }
    const data = await response.json();
    return data; // { id, fields: {…}, … }
  } catch (err) {
    console.error(`Erreur createAirtableRecord [${table}]:`, err);
    throw err;
  }
}

/**
 * Récupère des enregistrements depuis une table Airtable
 * @param {string} table — Nom de la table
 * @param {string} filter — Formule filterByFormula (optionnelle)
 * @returns {Promise<object[]>} — Liste de records
 */
export async function fetchAirtableRecord(table, filter = "") {
  const url = `https://api.airtable.com/v0/${BASE_ID}/${table}${
    filter ? `?filterByFormula=${encodeURIComponent(filter)}` : ""
  }`;

  try {
    const response = await fetch(url, {
      headers: {
        Authorization: `Bearer ${AIRTABLE_API_KEY}`,
        "Content-Type": "application/json",
      },
    });

    const data = await response.json();
    return data.records || [];
  } catch (err) {
    console.error(`Erreur fetch Airtable [${table}]:`, err);
    return [];
  }
}

/**
 * Met à jour un enregistrement dans une table Airtable
 * @param {string} table — Nom de la table
 * @param {string} recordId — ID de l’enregistrement à mettre à jour
 * @param {object} fields — Objet des champs à mettre à jour, e.g. { "Slug Cal": "nouveau-slug" }
 * @returns {Promise<object>} — Record mis à jour
 */
export async function updateAirtableRecord(table, recordId, fields) {
  const url = `https://api.airtable.com/v0/${BASE_ID}/${table}/${recordId}`;

  try {
    const response = await fetch(url, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${AIRTABLE_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ fields }),
    });

    const data = await response.json();
    return data;
  } catch (err) {
    console.error(`Erreur update Airtable [${table}/${recordId}]:`, err);
    throw err;
  }
}

